import { render, staticRenderFns } from "./BpmnRoleParameterContexts.vue?vue&type=template&id=1e297966&"
import script from "./BpmnRoleParameterContexts.vue?vue&type=script&lang=js&"
export * from "./BpmnRoleParameterContexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports